/**
 * Shared gate deciding whether the OT column/row is surfaced in a staffing view.
 *
 * OT is shown only when the view actually has OT data to render AND the department is not a medical
 * department (medical departments hide OT everywhere — grid, popup, and both mobile cards). Centralizing
 * the rule keeps the four views from drifting: the desktop grid gates its column on this, and the mobile
 * cards gate their OT row on the same call.
 */
export interface OtColumnVisibilityInput {
	/** True when the view has OT data to show (e.g. the first row carries an `overtimeHours` value). */
	hasOvertimeData: boolean;
	/** True for medical departments, where OT is never surfaced. */
	isMedicalDepartment: boolean;
}

export const shouldShowOtColumn = ({ hasOvertimeData, isMedicalDepartment }: OtColumnVisibilityInput): boolean => hasOvertimeData && !isMedicalDepartment;
